import { Component, HostBinding, Input } from '@angular/core';

@Component({
  selector: 'app-dot-pulse',
  imports: [],
  styleUrl: './dot-pulse.component.scss',
  template: '',
})
export class DotPulseComponent {
  @Input() size = 20;
  @Input() variant: 'success' | 'warning' = 'success';

  @HostBinding('attr.data-variant') get variantAttribute() {
    return this.variant;
  }

  @HostBinding('style.width.px') get width() {
    return this.size;
  }

  @HostBinding('style.height.px') get height() {
    return this.size;
  }

  @HostBinding('style.min-width.px') get minWidth() {
    return this.size;
  }
}
